var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('loading',{attrs:{"show":_vm.show,"label":_vm.label}}),_c('MainPage',{attrs:{"isLogged":_vm.isLogged,"version":_vm.version}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }